import React from "react";
import Footer from "../shared/Footer";
import "../styles/portal.css";

export default function SubmissionsPage() {
  return (
    <div style={{ width: "100%", margin: 0, padding: 0, overflowX: "hidden", backgroundColor: "#0d1b2a", minHeight: "100vh" }}>

      {/* Hero Banner */}
      <div style={heroBannerStyle}>
        <div style={heroContentStyle}>
          <h1 style={heroTitleStyle}>Submissions</h1>
          <p style={heroSubheadStyle}>
            Want to make comics with Antarctic Press? Here's everything you need to know.
          </p>
        </div>
      </div>

      {/* Page content */}
      <div style={pageBodyStyle}>

        <SubmissionCard title="How to Submit">
          <p style={bodyTextStyle}>
            Antarctic Press accepts pitches from creators at all levels. We publish creator-owned
            titles across all genres — manga-influenced, western, humor, horror, sci-fi, fantasy,
            and more.
          </p>
          <p style={bodyTextStyle}>
            Before submitting, read all of the guidelines on this page carefully. Submissions that
            do not follow these guidelines will not be reviewed.
          </p>
          <p style={bodyTextStyle}>
            We accept digital submissions. Please send PDF submissions to{" "}
            <a href="mailto:submissions@antarctic-press.com" style={inlineLinkStyle}>
              submissions@antarctic-press.com
            </a>
            .
          </p>
          <p style={bodyTextStyle}>
            You may also mail a physical submission package to the address listed below.
          </p>
        </SubmissionCard>

        <SubmissionCard title="Where to Send Your Physical Submissions">
          <p style={bodyTextStyle}>Mail your physical submission package to:</p>
          <div style={addressBlockStyle}>
            <strong>Antarctic Press</strong><br />
            Attn: Submissions<br />
            4334 Parkwood Dr<br />
            San Antonio, TX 78218
          </div>
          <p style={{ ...bodyTextStyle, marginTop: "1rem" }}>
            Submissions will not be returned, so if you are sending by mail please send
            photocopies of your work. Antarctic Press is not responsible for original art
            sent to us.
          </p>
        </SubmissionCard>

        <SubmissionCard title="Artist Submission Guide">
          <p style={bodyTextStyle}>
            <strong>We are only looking for completed work.</strong> We do not review works in
            progress or concept pitches without finished pages.
          </p>
          <p style={bodyTextStyle}>
            We do match creators to artists and writers. If you are looking for a collaborator,
            say so in your submission.
          </p>
          <p style={bodyTextStyle}>Include the following with your submission:</p>
          <ul style={listStyle}>
            <li>A minimum of 5 sequential pages of finished, inked artwork</li>
            <li>A one-page character design sheet</li>
            <li>A brief bio (one paragraph)</li>
            <li>Contact information (email and mailing address)</li>
          </ul>
          <p style={bodyTextStyle}>
            Do not send originals. Photocopies, printouts, or digital PDFs are preferred.
          </p>
        </SubmissionCard>

        <SubmissionCard title="Annual / Swimsuit Issue Guidelines">
          <p style={bodyTextStyle}>
            Antarctic Press publishes annual and swimsuit-themed issues featuring characters from
            our line. If you would like to contribute a pin-up or short piece to one of these
            specials, follow these guidelines:
          </p>
          <ul style={listStyle}>
            <li>Pin-ups should be single-page, full-color or greyscale</li>
            <li>Characters must be Antarctic Press properties or clearly licensed originals</li>
            <li>Artwork should be provided at 300 DPI minimum, print-ready</li>
            <li>Include a title block with your name, character name, and intended issue</li>
          </ul>
          <p style={bodyTextStyle}>
            <strong>Please do not mail the original art to us.</strong> We prefer digital PDF
            submissions sent to{" "}
            <a href="mailto:submissions@antarctic-press.com" style={inlineLinkStyle}>
              submissions@antarctic-press.com
            </a>
            .
          </p>
          <p style={bodyTextStyle}>
            While the creator does retain ownership of the artwork, all characters are held by
            their respective copyright owners.
          </p>
          <p style={bodyTextStyle}>
            Submission windows for annuals are announced on our social channels. Check our
            Facebook for open calls.
          </p>
        </SubmissionCard>

        <SubmissionCard title="AP Anthologies Guidelines">
          <p style={bodyTextStyle}>
            Antarctic Press periodically publishes themed anthology volumes. Open anthology calls
            are announced on our website and social media. When a call is open, submissions must:
          </p>
          <ul style={listStyle}>
            <li>Follow the specific theme of the announced anthology</li>
            <li>Be between 4 and 8 pages (unless otherwise specified)</li>
            <li>Be camera-ready, print-quality (300 DPI, CMYK or greyscale)</li>
            <li>Include a cover sheet with title, page count, creator name(s), and contact info</li>
          </ul>
          <p style={bodyTextStyle}>
            <strong>Please do not mail the original art to us.</strong> We prefer digital PDF
            submissions sent to{" "}
            <a href="mailto:submissions@antarctic-press.com" style={inlineLinkStyle}>
              submissions@antarctic-press.com
            </a>
            .
          </p>
          <p style={bodyTextStyle}>
            While the creator does retain ownership of the artwork, all characters are held by
            their respective copyright owners. Antarctic Press receives one-time print rights
            for the anthology volume.
          </p>
        </SubmissionCard>

        <SubmissionCard title="Before You Submit">
          <p style={bodyTextStyle}>
            Please review this checklist before sending anything to us. Incomplete packages slow
            down our review process and may result in your submission being set aside.
          </p>
          <ul style={listStyle}>
            <li>Have you read ALL submission guidelines on this page?</li>
            <li>Is your artwork/writing sample complete and print-ready?</li>
            <li>Have you included a one-page story synopsis (for writer submissions)?</li>
            <li>Is your contact information clearly visible on every page of your package?</li>
            <li>Are you submitting original/creator-owned work (not fan fiction or licensed IP)?</li>
          </ul>
          <p style={bodyTextStyle}>
            Antarctic Press does not publish work featuring characters from other publishers
            unless under an explicit licensing arrangement. Do not submit fan comics.
          </p>
        </SubmissionCard>

        <SubmissionCard title="State of the Industry">
          <p style={bodyTextStyle}>
            The independent comics industry is competitive and challenging. Antarctic Press has
            been publishing since 1985, and we have seen publishers come and go. We want creators
            to enter partnerships with us with realistic expectations.
          </p>
          <p style={bodyTextStyle}>
            Most new titles from independent publishers sell modestly. A successful new series
            may start with print runs in the low thousands. Digital distribution, crowdfunding,
            and merchandise can supplement print sales, but creators should not expect comics to
            be their primary income — especially early on.
          </p>
          <p style={bodyTextStyle}>
            We believe in creator-owned publishing because we believe creators deserve to own
            their work. That also means creators share the risk. We are transparent about this
            and encourage all prospective creators to research the market before submitting.
          </p>
        </SubmissionCard>

        <SubmissionCard title="How Our Company Works With Talent">
          <p style={bodyTextStyle}>
            Antarctic Press is a creator-owned publisher. Here is what that means in practice:
          </p>
          <ul style={listStyle}>
            <li>
              <strong>You own your work.</strong> All rights to your characters and story remain
              with you. We do not acquire IP ownership as a condition of publishing.
            </li>
            <li>
              <strong>We split print revenues.</strong> Specific royalty splits are negotiated
              per title. Ask during the pitch process for current standard terms. Any royalties
              are subject to any listing fees required by the distributor.
            </li>
            <li>
              <strong>We handle print and distribution.</strong> Antarctic Press manages printing,
              Lunar distribution, and fulfillment. Creators focus on making the book.
            </li>
            <li>
              <strong>Digital rights are negotiated separately.</strong> Digital distribution
              through our platform and third-party services is covered in the publishing agreement.
            </li>
            <li>
              <strong>No advance against royalties.</strong> We do not pay advances. Creators
              earn from sales after print costs are recouped.
            </li>
          </ul>
          <p style={bodyTextStyle}>
            We work with new and established creators alike. If you have questions not covered
            here, reach out to us through the submission address above and include "Publishing
            Inquiry" in your envelope.
          </p>
        </SubmissionCard>

        
      </div>
      <Footer style={{ marginTop: 0 }} />
    </div>
  );
}

function SubmissionCard({ title, children }) {
  return (
    <div style={cardStyle}>
      <h2 style={cardTitleStyle}>{title}</h2>
      <div>{children}</div>
    </div>
  );
}

const heroBannerStyle = {
  background: "linear-gradient(135deg, #0d1b2a 0%, #114c96 100%)",
  padding: "64px 16px 56px",
  borderBottom: "3px solid #43c6f9",
};

const heroContentStyle = {
  maxWidth: "960px",
  margin: "0 auto",
};

const heroTitleStyle = {
  color: "#ffffff",
  fontWeight: 900,
  fontSize: "2.8rem",
  margin: "0 0 0.5rem 0",
  letterSpacing: "0.02em",
};

const heroSubheadStyle = {
  color: "#43c6f9",
  fontSize: "1.15rem",
  margin: 0,
  fontWeight: 500,
};

const pageBodyStyle = {
  maxWidth: "960px",
  margin: "0 auto",
  padding: "40px 16px 24px",
};

const cardStyle = {
  backgroundColor: "#ffffff",
  border: "1px solid #d7e2ef",
  borderTop: "4px solid #114c96",
  borderRadius: "12px",
  padding: "2rem 2rem 1.5rem",
  marginBottom: "24px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
};

const cardTitleStyle = {
  color: "#114c96",
  fontWeight: 800,
  fontSize: "1.35rem",
  margin: "0 0 1rem 0",
};

const bodyTextStyle = {
  color: "#334155",
  lineHeight: 1.75,
  margin: "0 0 0.75rem 0",
};

const inlineLinkStyle = {
  color: "#114c96",
  fontWeight: 700,
};

const listStyle = {
  color: "#334155",
  lineHeight: 1.75,
  paddingLeft: "1.5rem",
  marginBottom: "0.75rem",
};

const addressBlockStyle = {
  backgroundColor: "#f0f6ff",
  border: "1px solid #c9daf8",
  borderRadius: "8px",
  padding: "1rem 1.25rem",
  color: "#1e3a5f",
  lineHeight: 1.9,
  fontFamily: "monospace",
  fontSize: "0.95rem",
};
